<app-section #parentSection
             [formConfig]="formConfig"
             [sectionRef]="section"
             [formGroup]="formGroup"
             [key]="key"
             [containerClass]="nextInsuranceCoveragesSection"
             [editMode]="false">

  <ng-template #section>

    <div  class="insurance-coverages-section">
      <p *ngIf="titleVisible"
         class="insurance-coverages-section__title">
        {{ sectionTitle | translate }}
      </p>

      <div class="insurance-coverages-section__container">

        <ng-container *ngIf="nextInsuranceCoveragesSection; else insuranceCoveragesSection">
          <app-checkbox *ngFor="let coverage of availableCoverages"
                        [bean]="bean"
                        [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[coverage]"
                        [fieldConfig]="formFactoryService.fieldConfig(coverage, formConfig)"
                        [context]="formConfig.formKey"
                        class="insurance-coverages-section__coverage"
                        [class.insurance-coverages-section__coverage--disabled]="isCoverageDisabled(coverage)"
                        (click)="onCoverageClick(coverage)"
                        [ngClass]="coverageClassName(coverage)"
          >
          </app-checkbox>
        </ng-container>

        <ng-template #insuranceCoveragesSection>
          <app-checkbox *ngFor="let coverage of availableCoverages"
                        [bean]="bean"
                        [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[coverage]"
                        [fieldConfig]="formFactoryService.fieldConfig(coverage, formConfig)"
                        [context]="formConfig.formKey"
                        class="insurance-coverages-section__coverage"
                        [ngClass]="coverageClassName(coverage)"
          >
          </app-checkbox>
        </ng-template>
      </div>

      <div class="section__end"></div>
    </div>

  </ng-template>
</app-section>
